"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createThemeSessionResolver = void 0;
const theme_provider_1 = require("./theme-provider");
const createThemeSessionResolver = (cookieThemeSession) => {
    const resolver = async (request) => {
        const session = await cookieThemeSession.getSession(request.headers.get('Cookie'));
        return {
            getTheme: () => {
                const themeValue = session.get('theme');
                return (0, theme_provider_1.isTheme)(themeValue) ? themeValue : null;
            },
            setTheme: (theme) => session.set('theme', theme),
            commit: () => cookieThemeSession.commitSession(session),
        };
    };
    return resolver;
};
exports.createThemeSessionResolver = createThemeSessionResolver;
